<template>
  <div id="logo">
    <canvas ref="hexagon" id="hexagon" width="98" height="106">Chargement des données</canvas>
    <div class="wave"></div>
  </div>
</template>

<script>
export default {
  name: 'AppLogo',
  mounted() {
    this.drawHexagon()
  },
  methods: {
    drawHexagon() {
      const canvas = this.$refs.hexagon
      const ctx = canvas.getContext('2d')

      ctx.lineWidth = 4
      ctx.strokeStyle = '#68cfde'

      ctx.moveTo(49, 2)
      ctx.lineTo(95, 28)
      ctx.lineTo(89, 84)
      ctx.lineTo(49, 103)
      ctx.lineTo(7, 73)
      ctx.lineTo(4, 25)
      ctx.lineTo(50, 3)

      const region = new Path2D()
      region.lineTo(0, 0)
      region.lineTo(0, 106)
      region.lineTo(98, 106)
      region.lineTo(98, 0)
      region.moveTo(49, 0)
      region.lineTo(97, 27)
      region.lineTo(91, 85)
      region.lineTo(49, 105)
      region.lineTo(5, 74)
      region.lineTo(2, 24)
      region.lineTo(50, 1)
      region.closePath()

      ctx.stroke()
      ctx.fillStyle = '#F0F4F7'
      ctx.fill(region, 'evenodd')
    }
  }
}
</script>

<style lang="scss" scoped>
@import './Logo.scss';
</style>
